import Vue from 'vue'
import Router from 'vue-router'

// http://222.143.32.186/tacs-uc/login/index/?backUrl=http://localhost:8888/zwLogin?targetUrl=http://localhost:8888/zwLogin

Vue.use(Router);
//登录
const Login = () => import('../page/login/index.vue');
// 个人登录
const LoginPer = () => import('../page/login/loginPer/index.vue');
// 单位登录
const LoginCom = () => import('../page/login/loginCom/index.vue');
// 开发商登录
const LoginDev = () => import('../page/login/loginDev/index.vue');


//注册
const Register = () => import('../page/login/register/index.vue');
// 个人注册
const RegisterPer = () => import('../page/login/register/per');
// 单位注册
const RegisterCom = () => import('../page/login/register/com');

const RegisterDev = () => import('../page/login/register/dev');
// 成功页面
const Success = () => import('../page/login/success/index');
// 个人密码重置
const forgetPer = () => import('../page/login/forget/per/index.vue');
// 单位密码重置
const forgetCom = () => import('../page/login/forget/com/index.vue');

// 开发商密码重置
const forgetDev = () => import('../page/login/forget/dev/index.vue');
//二维码
const QRcode = () => import('../page/login/QRcode.vue');
// 政务登录

// http://222.143.32.186/tacs-uc/login/index/?backUrl=http://localhost:8888/zwLogin?targetUrl=http://localhost:8888/zwLogin
const zwLogin = () => import('../page/login/zwLogin/index');

const perAccountNew = () => import('../page/login/per-account/new/index.vue');
const perAccountProgress = () => import('../page/login/per-account/progress/index.vue');

// 开发商预登记
const devAccountNew = ()=>import('../page/login/dev-account/new/index.vue');

// 开发商预登记进度查询

const dAccountProgress = ()=>import('../page/login/dev-account/progress/index.vue')

export default new Router({
    routes: [{
        path: '/',
        redirect: '/login'
    }, {
        path: '/login',
        name: 'Login',
        component: Login
    }, {
        path: '/loginPer',
        name: 'LoginPer',
        component: LoginPer
    }, {
        path: '/loginCom',
        name: 'LoginCom',
        component: LoginCom
    },
        {
            path: '/loginDev',
            name: 'LoginDev',
            component: LoginDev
        },

        {
        path: '/register',
        name: 'Register',
        component: Register
    },  {
        path: '/registerPer',
        name: 'registerPer',
        component: RegisterPer
    },  {
        path: '/registerCom',
        name: 'registerCom',
        component: RegisterCom
    },

        {
            path: '/registerDev',
            name: 'registerDev',
            component: RegisterDev
        },
        {
        path: '/forgetPer',
        name: 'forgetPer',
        component: forgetPer
    },   {
        path: '/forgetCom',
        name: 'forgetCom',
        component: forgetCom
    },
        {
            path: '/forgetDev',
            name: 'forgetDev',
            component: forgetDev
        },
        {
        path: '/success',
        name: 'Success',
        component: Success
    },{
        path: '/QRcode',
        name: 'QRcode',
        component: QRcode
    },{
        path: '/zwLogin',
        name: 'zwLogin',
        component: zwLogin
    },{
        path: '/pernew',
        name: 'pernew',
        component: perAccountNew
    },{
        path: '/perprogress',
        name: 'perprogress',
        component: perAccountProgress
    },
        {
            path: '/devnew',
            name: 'devnew',
            component: devAccountNew
        },
        {
            path: '/devprogress',
            name: 'devprogress',
            component: dAccountProgress
        },

    ]
})



// WEBPACK FOOTER //
// ./src/router/login.js